import { reloadPage } from './meta'

export const actionTypes = {
  GOBACK: 'history/GOBACK',
}

export const backbutton = (q) => {
  return (dispatch, getStore) => {

    if (q &&
       q.page &&
      (q.page != getStore().meta.page)
    ) {
      dispatch(reloadPage(q.page))
    }
    dispatch(goBack())
  }
}


export const goBack = () => {
  return {
    type: actionTypes.GOBACK
  }
}



// WEBPACK FOOTER //
// ./src/actions/history.js